import { useState, useCallback } from "react";
import type { Site } from "../../../types/Site";
import { SiteSelectorProps } from "../ui/SiteSelector";

export const useSite = ({
    allowedSites,
    selectedSite,
    setSelectedSite,
}: SiteSelectorProps) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(true);

    const handleSetSelectedSite = useCallback(
        (site: Site) => {
            setSelectedSite(site);
            localStorage.setItem("selected_site", site.id);
        },
        [setSelectedSite],
    );

    const toggleDropdown = useCallback(() => {
        setIsDropdownOpen((prev) => !prev);
    }, []);

    return {
        allowedSites,
        selectedSite,
        setSelectedSite: handleSetSelectedSite,
        isDropdownOpen,
        toggleDropdown,
    };
};
